import { BASE_URL } from '../config/config'
import { builder } from '../utils/queryBuilder'
import Fetch from './Fetch'

//admin services
export const getAllAnnouncementByAdmin = async body => {
    const params = builder({
        take: body.take,
        skip: body.skip,
    })
    return await Fetch.get(`${BASE_URL}announcement/admin/all${params}`)
}

export const addNewAnnouncementByAdmin = body =>
    Fetch.post(`${BASE_URL}announcement/admin`, body)

export const updateAnnouncementByAdmin = (id, body) =>
    Fetch.patch(`${BASE_URL}announcement/admin/${id}`, JSON.stringify(body), {
        headers: {
            'Content-Type': 'application/json',
        },
    })
export const deleteAnnouncementByAdmin = id =>
    Fetch.delete(`${BASE_URL}announcement/admin/${id}`)
// --------------------

export const getAnAnnouncement = id =>
    Fetch.get(`${BASE_URL}announcement/${id}`)

export const getAllAnnouncement = async body => {
    const params = builder({
        take: body.take,
        skip: body.skip,
    })
    return await Fetch.get(`${BASE_URL}announcement${params}`)
}
